import { useEffect, useState } from 'react';

/** Whether a media query matches, following changes. Where matchMedia is missing (tests, old browsers) it answers `fallback`. */
export function useMedia(query: string, fallback = true): boolean {
  const read = () => { try { return typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : fallback; } catch { return fallback; } };
  const [on, setOn] = useState(read);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    let mq: MediaQueryList;
    try { mq = window.matchMedia(query); } catch { return; }
    const update = () => setOn(mq.matches);
    update();
    mq.addEventListener?.('change', update);
    return () => mq.removeEventListener?.('change', update);
  }, [query]);
  return on;
}
/** The two-column Battle builder layout (Tailwind's xl): the run sheet's summary sticks beside the list. */
export const WIDE = '(min-width: 1280px)';
